import React from 'react';
import { Link } from 'react-router-dom';
import SimplePage, { Card } from '../components/SimplePage';

const About = () => (
  <SimplePage title="About CyberGuard Global" subtitle="Straightforward security tools for everyday people and small teams">
    <Card title="What we do">
      <p>
        CyberGuard Global helps you check what you're unsure about before you trust it: a link in a text, an email
        attachment, a file or an IP address. We bring trusted, well-known security services together in one place and
        explain the results in plain language.
      </p>
      <p>
        We also help you use the privacy protections already built into your devices, with a guided checklist for
        Apple's privacy controls and Safety Check.
      </p>
    </Card>

    <Card title="How we work">
      <ul className="list-disc pl-6 space-y-2">
        <li><strong className="text-white">Every result shows its source.</strong> Checks use VirusTotal, Google Safe Browsing, PhishTank and AbuseIPDB.</li>
        <li><strong className="text-white">We say when we couldn't check.</strong> If a service can't be reached, we tell you instead of calling something safe.</li>
        <li><strong className="text-white">We ask for the least access we need.</strong> Email Protection uses read-only access, and Scam Check analyzes message text on your phone.</li>
        <li><strong className="text-white">We're clear about limits.</strong> iOS doesn't let any app scan an iPhone for spyware, and no service can promise every threat is caught.</li>
      </ul>
    </Card>

    <Card title="Get in touch">
      <p>
        Questions, feedback or partnership enquiries: <a href="mailto:team@cyberguardglobal.com" className="text-cyan-400 hover:underline">team@cyberguardglobal.com</a>,
        or use our <Link to="/contact" className="text-cyan-400 hover:underline">contact form</Link>.
      </p>
    </Card>
  </SimplePage>
);

export default About;
